//-------------------------------------------------------------------------------------------------- Imports
import { Row, Col, Card, Typography, Button } from "antd";
import { StyleSheet } from "../../StyleSheet";
import SubDefaultLayout from "../../components/SubDefaultLayout";
import { useCallback, useEffect, useState } from "react";
import { checkLevels, getDique, getIncognito } from "../../methods/Methods";
import { images } from "../../routes/ImageRoutes"
import { useSelector } from "react-redux";
import { getGeneralData } from "../../stores/slices/generalDataSlice";
import { InfoCircleOutlined } from "@ant-design/icons";
import UpdateSignal from "./UpdateSignal";
import Provission from "./Provission";
import ContactAgent from "./ContactAgent";
import _ from "lodash";
const { Text } = Typography;

//-------------------------------------------------------------------------------------------------- View
const TechnicalDiagnostics = () => {
    const generalData = useSelector(getGeneralData);
    const [diqueStatus, setDiqueStatus] = useState<number>(0);
    const [checkLevelsStatus, setCheckLevelsStatus] = useState<number>(0);
    const [incognitoStatus, setIncognitoStatus] = useState<number>(0);

    const [iconRightDique, setIconRightDique] = useState(images.loadingSpinnerGif);
    const [styleTextIconRightDique, setStyleTextIconRightDique] = useState<any>(styles.textRegular);
    const [textIconRightDique, setTextIconRightDique] = useState("Diagnosticando...");
    const [iconRightIncognito, setIconRightIncognito] = useState(images.loadingSpinnerGif);
    const [styleTextIconRightIncognito, setStyleTextIconRightIncognito] = useState<any>(styles.textRegular);
    const [textIconRightIncognito, setTextIconRightIncognito] = useState("Diagnosticando...");
    const [iconRightCheckLevels, setIconRightCheckLevels] = useState(images.loadingSpinnerGif);
    const [styleTexticonRightCheckLevels, setStyleTextIconRightCheckLevels] = useState<any>(styles.textRegular);
    const [texticonRightCheckLevels, setTextIconRightCheckLevels] = useState("Diagnosticando...");
    const [diagnosticMessage, setDiagnosticMessage] = useState("");
    const [showDiagnosticMessage, setShowDiagnosticMessage] = useState<boolean>(false);
    const [textButton, setTextButton] = useState("");
    const [showButton, setShowButton] = useState<boolean>(false);
    const [goReset, setGoReset] = useState<boolean>(false);
    const [goChat, setGoChat] = useState<boolean>(false);
    const [goProvision, setGoProvision] = useState<boolean>(false);
    const [canProvision, setCanProvision] = useState<boolean>(false);
    const [showReset, setShowReset] = useState<boolean>(false);
    const [showChat, setShowChat] = useState<boolean>(false);
    const [showProvision, setShowProvision] = useState<boolean>(false);
    const [idCliente, setIdCliente] = useState<string>("");

    const [hasWifi24Data, setHasWifi24Data] = useState<boolean>(false);
    const [wifi24Status, setWifi24Status] = useState("");
    const [wifi24Ssid, setWifi24Ssid] = useState("");
    const [wifi24SecMode, setWifi24SecMode] = useState("");

    const [hasWifi5Data, setHasWifi5Data] = useState<boolean>(false);
    const [wifi5Status, setWifi5Status] = useState("");
    const [wifi5Ssid, setWifi5Ssid] = useState("");
    const [wifi5SSecMode, setWifi5SecMode] = useState("");

    // diagnostico de la señal
    const getCheckLevelsResponse = useCallback(async (idCliente: string) => {
        setHasWifi24Data(false);
        setHasWifi5Data(false);

        await checkLevels(idCliente)
            .then((response) => {
                if (response.data.data[0].status === "OK" &&
                    response.data.data[0].resultado === "1") {
                    setIconRightCheckLevels(images.iconSuccess);
                    setStyleTextIconRightCheckLevels(styles.textSuccess);
                    setTextIconRightCheckLevels("¡OK!");
                    setCheckLevelsStatus(1);

                    if (!_.isEmpty(response.data.data[0].wifiInfo24.ssid)) {
                        setHasWifi24Data(true);
                        setWifi24Status(response.data.data[0].wifiInfo24.active ? "Activo" : "Inactivo");
                        setWifi24Ssid(response.data.data[0].wifiInfo24.ssid);
                        setWifi24SecMode(response.data.data[0].wifiInfo24.securityMode);
                    }

                    if (!_.isEmpty(response.data.data[0].wifiInfo5.ssid)) {
                        setHasWifi5Data(true);
                        setWifi5Status(response.data.data[0].wifiInfo5.active ? "Activo" : "Inactivo");
                        setWifi5Ssid(response.data.data[0].wifiInfo5.ssid);
                        setWifi5SecMode(response.data.data[0].wifiInfo5.securityMode);
                    }

                } else if (response.data.data[0].status === "ERROR" &&
                    response.data.data[0].resultado === "1") {
                    setStyleTextIconRightCheckLevels(styles.textError);
                    setTextIconRightCheckLevels("¡Falla!");
                    setIconRightCheckLevels(images.iconError);
                    setCheckLevelsStatus(2);
                } else {
                    setStyleTextIconRightCheckLevels(styles.textError);
                    setIconRightCheckLevels(images.iconError);
                    setTextIconRightCheckLevels("¡Falla!");
                    setCheckLevelsStatus(3);
                }
            })
            .catch((error) => {
                setIconRightCheckLevels(images.iconSuccess);
                setStyleTextIconRightCheckLevels(styles.textSuccess);
                setTextIconRightCheckLevels("¡OK!");
                setCheckLevelsStatus(1);
            });
    }, []);

    // diagnostico del equipo
    const getIncognitoResponse = useCallback(async (idCliente: string) => {
        await getIncognito(idCliente)
            .then((response) => {
                if (response.data.data[0].status === "OK" &&
                    response.data.data[0].resultado === "1") {
                    setIconRightIncognito(images.iconSuccess);
                    setStyleTextIconRightIncognito(styles.textSuccess);
                    setTextIconRightIncognito("¡OK!");
                    setIncognitoStatus(1);
                    getCheckLevelsResponse(idCliente);
                } else if (response.data.data[0].status === "ERROR" &&
                    response.data.data[0].resultado === "1" &&
                    response.data.data[0].aprovisionar === "0") {
                    setStyleTextIconRightIncognito(styles.textError);
                    setTextIconRightIncognito("¡Falla!");
                    setIconRightIncognito(images.iconError);
                    setIncognitoStatus(2);
                    setCanProvision(true);
                } else if (response.data.data[0].status === "ERROR" &&
                    response.data.data[0].resultado === "1" &&
                    response.data.data[0].aprovisionar !== "0") {
                    setStyleTextIconRightIncognito(styles.textError);
                    setTextIconRightIncognito("¡Falla!");
                    setIconRightIncognito(images.iconError);
                    setIncognitoStatus(2);
                    setCanProvision(false);
                } else {
                    setIconRightIncognito(images.iconSuccess);
                    setStyleTextIconRightIncognito(styles.textSuccess);
                    setTextIconRightIncognito("¡OK!");
                    setIncognitoStatus(1);
                    getCheckLevelsResponse(idCliente);
                }
            })
            .catch((error) => {
                setStyleTextIconRightIncognito(styles.textError);
                setIconRightIncognito(images.iconError);
                setTextIconRightIncognito("¡Falla!");
                setIncognitoStatus(3);
                getCheckLevelsResponse(idCliente);
            });
    }, [getCheckLevelsResponse]);

    const getDiqueResponse = useCallback(async (idCliente: string) => {
        await getDique(idCliente, "web")
            .then((response) => {
                if (response.data.data[0].resultado === "1") {
                    setStyleTextIconRightDique(styles.textError);
                    setTextIconRightDique("¡Falla!");
                    setIconRightDique(images.iconError);
                    setDiqueStatus(2);
                } else {
                    setIconRightDique(images.iconSuccess);
                    setStyleTextIconRightDique(styles.textSuccess);
                    setTextIconRightDique("¡OK!");
                    setDiqueStatus(1);
                    getIncognitoResponse(idCliente);
                }
            })
            .catch((error) => {
                setIconRightDique(images.iconSuccess);
                setStyleTextIconRightDique(styles.textSuccess);
                setTextIconRightDique("¡OK!");
                setDiqueStatus(1);
                getIncognitoResponse(idCliente);
            });
    }, [getIncognitoResponse]);


    const handleNavigation = () => {
        if (goProvision) {
            setShowProvision(true);
        }
        if (goReset) {
            setShowReset(true);
        }
        if (goChat) {
            setShowChat(true);
        }
    };

    useEffect(() => {
        if (generalData.selectedContract !== null) {
            setIdCliente(
                generalData.selectedContract.sucursal + generalData.selectedContract.suscriptor
            );
        }
    }, [generalData.selectedContract]);

    useEffect(() => {
        if (idCliente) {
            setDiqueStatus(0);
            setCheckLevelsStatus(0);
            setIncognitoStatus(0);
            setIconRightDique(images.loadingSpinnerGif);
            setIconRightCheckLevels(images.loadingSpinnerGif);
            setIconRightIncognito(images.loadingSpinnerGif);
            setTextIconRightDique("Diagnosticando...");
            setTextIconRightCheckLevels("Diagnosticando...");
            setTextIconRightIncognito("Diagnosticando...");
            setStyleTextIconRightDique(styles.textRegular);
            setStyleTextIconRightCheckLevels(styles.textRegular);
            setStyleTextIconRightIncognito(styles.textRegular);
            getDiqueResponse(idCliente);
        }
    }, [idCliente, getDiqueResponse]);

    useEffect(() => {
        if (diqueStatus !== 0) {
            if (diqueStatus === 2 || diqueStatus === 3) {
                setTextButton("Regresar");
                if (diqueStatus === 2) {
                    setDiagnosticMessage("Detectamos una falla en su zona, nuestro equipo de técnicos ya está trabajando en resolverlo a la brevedad, no es necesario que lo reporte.");
                } else {
                    setDiagnosticMessage("No fue posible realizar el diagnostico en su zona.");
                }
                setShowDiagnosticMessage(true);
                setShowButton(true);
            } else if (checkLevelsStatus === 2) {
                setTextButton("Restablecer Señal");
                setDiagnosticMessage("Detectamos una falla en su servicio de internet, puede probar restablecer su señal.");
                setGoReset(true);
                setShowDiagnosticMessage(true);
                setShowButton(true);
            } else if (incognitoStatus === 2) {
                if (canProvision) {
                    setTextButton("Reaprovisionar equipo")
                    setDiagnosticMessage("Detectamos una falla en su equipo, puede probar reaprovisionarlo.");
                    setGoProvision(true);
                    setShowDiagnosticMessage(true);
                    setShowButton(true);
                } else {
                    setTextButton("Contacta a un agente");
                    setDiagnosticMessage("Si aún presenta problema en su servicio, favor de comunicarse al área de servicio al cliente.");
                    setGoChat(true);
                    setShowDiagnosticMessage(true);
                    setShowButton(true);
                }
            } else if (checkLevelsStatus === 1 && incognitoStatus === 1) {
                setTextButton("Contacta a un agente");
                setDiagnosticMessage("Diagnostico exitoso, si aún presenta problema en su servicio, favor de comunicarse al área de servicio al cliente.");
                setGoChat(true);
                setShowDiagnosticMessage(true);
                setShowButton(true);
            } else if (checkLevelsStatus === 3 || incognitoStatus === 3) {
                setTextButton("Contacta a un agente");
                setDiagnosticMessage("¡No se pudo diagnosticar!");
                setGoChat(true);
                setShowDiagnosticMessage(true);
                setShowButton(true);
            }
        };
    }, [diqueStatus, checkLevelsStatus, incognitoStatus, canProvision]);

    return (
        <>
            <SubDefaultLayout title={showReset ? 'Restablecer Señal' : showProvision ? 'Reaprovisionar Equipo' : showChat ? 'Contacta a un Agente' : 'Diagnóstico Técnico'} needReturn={true} navigateTo={"/technical-support"} >
                {
                    showReset ?
                        <UpdateSignal />
                        : showProvision ?
                            <Provission />
                            : showChat ?
                                <ContactAgent />
                                :
                                <>
                                    <Row style={styles.rowCardPrincipal} justify={"center"}>
                                        <Col xs={16} xl={14} style={{ paddingLeft: 10 }}>
                                            <Card style={{ ...styles.cardRoot, marginTop: 10 }}>
                                                <Row style={styles.rowPrincipal}>
                                                    <Col xs={5} style={{ display: 'flex', alignItems: 'center' }}>
                                                        <img style={styles.logoIcon} src={images.iconDique} alt={""} />
                                                    </Col>
                                                    <Col xs={14} style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                                        <Text style={{ ...styles.textContain }}>
                                                            {
                                                                diqueStatus === 0 ?
                                                                    "Revisando si hay falla en la zona..." : diqueStatus === 1 ?
                                                                        "¡No hay falla en su zona!" : diqueStatus === 2 ?
                                                                            "¡Hay una falla en su zona!" : "¡No se pudo diagnosticar!"
                                                            }
                                                        </Text>
                                                    </Col>
                                                    <Col xs={5} style={styles.colText}>
                                                        <img style={styles.logoIcon} src={iconRightDique} alt={""} />
                                                        <div>
                                                            <Text style={styleTextIconRightDique}>
                                                                {textIconRightDique}
                                                            </Text>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>
                                    </Row>
                                    {
                                        diqueStatus === 1 ? (
                                            <>
                                                <Row style={styles.rowCardPrincipal} justify={"center"}>
                                                    <Col xs={16} xl={14} style={{ paddingLeft: 10 }}>
                                                        <Card style={styles.cardRoot}>
                                                            <Row align={"middle"} justify={"center"}>
                                                                <Col xs={5}>
                                                                    <img style={styles.logoIcon} src={images.iconIncognito} alt={""} />
                                                                </Col>
                                                                <Col xs={14}>
                                                                    <Text style={{ ...styles.textContain }}>
                                                                        {
                                                                            incognitoStatus === 0 ?
                                                                                "Revisando su equipo" : incognitoStatus === 1 ?
                                                                                    "Equipo funciona correctamente." : incognitoStatus === 2 ?
                                                                                        "¡Equipo presenta fallas!" : "¡No se pudo diagnosticar!"
                                                                        }
                                                                    </Text>
                                                                </Col>
                                                                <Col xs={5} style={styles.colText}>
                                                                    <img style={styles.logoIcon} src={iconRightIncognito} alt={""} />
                                                                    <div>
                                                                        <Text style={styleTextIconRightIncognito}>
                                                                            {textIconRightIncognito}
                                                                        </Text>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </Card>
                                                    </Col>
                                                </Row>
                                                {
                                                    incognitoStatus === 1 ? (
                                                        <Row style={styles.rowCardPrincipal} justify={"center"}>
                                                            <Col xs={16} xl={14} style={{ paddingLeft: 10 }}>
                                                                <Card style={styles.cardRoot}>
                                                                    <Row style={styles.rowPrincipal}>
                                                                        <Col xs={5} style={{ display: 'flex', alignItems: 'center' }}>
                                                                            <img style={styles.logoIcon} src={images.iconCheckLevels} alt={""} />
                                                                        </Col>
                                                                        <Col xs={14} style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                                                            <Text style={{ ...styles.textContain }}>
                                                                                {
                                                                                    checkLevelsStatus === 0 ?
                                                                                        "Revisando servicio de internet" : checkLevelsStatus === 1 ?
                                                                                            "Con servicio de internet." : checkLevelsStatus === 2 ?
                                                                                                "¡Sin servicio de internet!" : "¡No se pudo diagnosticar!"
                                                                                }
                                                                            </Text>
                                                                        </Col>
                                                                        <Col xs={5} style={styles.colText}>
                                                                            <img style={styles.logoIcon} src={iconRightCheckLevels} alt={""} />
                                                                            <div>
                                                                                <Text style={styleTexticonRightCheckLevels}>
                                                                                    {texticonRightCheckLevels}
                                                                                </Text>
                                                                            </div>
                                                                        </Col>
                                                                        {
                                                                            hasWifi24Data || hasWifi5Data ?
                                                                                <Col xs={24} style={{ paddingTop: 15 }}>
                                                                                    <Row justify={"center"} align={"middle"}>
                                                                                        {
                                                                                            hasWifi24Data ?
                                                                                                <>
                                                                                                    <Col xs={4} xxl={2}>
                                                                                                        <img
                                                                                                            alt=""
                                                                                                            style={styles.diagnosticIconNetwork}
                                                                                                            src={images.icon24g}
                                                                                                        />
                                                                                                    </Col>
                                                                                                    <Col xs={8} xxl={10} style={{ lineHeight: 0.5 }}>
                                                                                                        <Text style={styles.diagnosticMessageStyle}>
                                                                                                            {`Prueba de red 2.4G completada con éxito. \nEstado: ${wifi24Status}  \nSSID: ${wifi24Ssid} \nModo de seguridad: ${wifi24SecMode}`}
                                                                                                        </Text>
                                                                                                    </Col>
                                                                                                </>
                                                                                                :
                                                                                                null
                                                                                        }
                                                                                        {
                                                                                            hasWifi5Data ?
                                                                                                <>
                                                                                                    <Col xs={4} xxl={2}>
                                                                                                        <img
                                                                                                            alt=""
                                                                                                            style={styles.diagnosticIconNetwork}
                                                                                                            src={images.icon5g}
                                                                                                        />
                                                                                                    </Col>
                                                                                                    <Col xs={8} xxl={10} style={{ lineHeight: 0.5 }}>
                                                                                                        <Text style={styles.diagnosticMessageStyle}>
                                                                                                            {`Prueba de red 5G completada con éxito. \nEstado: ${wifi5Status}  \nSSID: ${wifi5Ssid} \nModo de seguridad: ${wifi5SSecMode}`}
                                                                                                        </Text>
                                                                                                    </Col>
                                                                                                </>
                                                                                                :
                                                                                                null
                                                                                        }
                                                                                    </Row>
                                                                                </Col>
                                                                                :
                                                                                null
                                                                        }
                                                                    </Row>
                                                                </Card>
                                                            </Col>
                                                        </Row>
                                                    ) : null
                                                }

                                            </>
                                        ) : null
                                    }
                                    {
                                        showDiagnosticMessage ?
                                            <Row style={styles.rowCardPrincipal} justify={"center"}>
                                                <Col xs={16} xl={14} style={{ paddingLeft: 10 }}>
                                                    <Card style={{
                                                        ...styles.cardError,
                                                        backgroundColor: diqueStatus === 1 && checkLevelsStatus === 1 && incognitoStatus === 1 ? '#d9e6f6' : "#F74D09"
                                                    }}>
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <InfoCircleOutlined style={{
                                                                ...styles.icon,
                                                                color: diqueStatus === 1 && checkLevelsStatus === 1 && incognitoStatus === 1 ? '#0156c3' : "#d9e6f6"
                                                            }} />
                                                            <Text style={{
                                                                ...styles.description,
                                                                color: diqueStatus === 1 && checkLevelsStatus === 1 && incognitoStatus === 1 ? "#0156c3" : "white",
                                                            }}>
                                                                {diagnosticMessage}
                                                            </Text>
                                                        </div>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            : null
                                    }
                                    {
                                        showButton ?
                                            <Row style={{ display: 'flex', justifyContent: 'center', width: '100%', marginTop: 30 }}>
                                                <Button style={styles.buttonFinal}
                                                    type="primary"
                                                    onClick={() => handleNavigation()}
                                                >
                                                    {textButton}
                                                </Button>
                                            </Row>
                                            : null
                                    }
                                </>
                }
            </SubDefaultLayout >
        </>
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    cardRoot: {
        backgroundColor: 'white',
        marginBottom: 15,
        boxShadow: "0px 0px 8px #00000029",
        borderRadius: 20
    },
    cardError: {
        borderRadius: 15,
        width: '100%'
    },
    rowCardPrincipal: {
        marginTop: 10,
    },
    rowPrincipal: {
        display: 'flex',
    },
    textContain: {
        fontSize: 15,
        color: "#000000",
        textAlign: 'left',
        fontWeight: 600
    },
    logoIcon: {
        resizeMode: 'contain',
        width: 39,
        height: 39
    },
    colText: {
        alignItems: 'center',
        textAlign: 'center'
    },
    icon: {
        fontSize: 15,
    },
    description: {
        textAlign: 'left',
        fontSize: 12,
        marginLeft: 8,
    },
    buttonFinal: {
        backgroundColor: '#0055c2',
        borderRadius: 15,
        color: 'white',
        boxShadow: "3px 3px 5px 0px rgba(0,0,0,0.10)",
        marginBottom: 10
    },
    textRegular: {
        fontSize: 10,
        color: '#1253a4',
        fontWeight: 600
    },
    textError: {
        fontSize: 10,
        color: 'red',
        marginTop: 0
    },
    textSuccess: {
        fontSize: 10,
        color: '#00ff77',
        marginTop: 0
    },
    diagnosticMessageStyle: {
        fontSize: 10,
        color: "#000000",
        textAlign: 'left',
        whiteSpace: 'pre-wrap',
        lineHeight: 1.2
    },
    diagnosticTitle: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        display: 'flex',
        alignItems: 'center'
    },
    diagnosticIconView: {
        width: "15%",
        display: 'flex',
    },
    diagnosticIconNetwork: {
        width: 40,
    }
});

//-------------------------------------------------------------------------------------------------- Exports
export default TechnicalDiagnostics;
